<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="./">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <router-link to="/stujapcollect">日语汇总</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>学历统计</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 主体内容 -->
    <div class="content">
      <el-form inline label-position="right" label-width="60px" size="small" class="query-form">
        <el-form-item label="时间">
          <el-date-picker
            v-model="query.time"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            @change="yearSearch();"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="yearSearch();">查询</el-button>
        </el-form-item>
      </el-form>

      <div style="height:20px;"></div>
      <el-row :gutter="24" class="row">
        <el-col :span="12">
          <el-card class="box-card" shadow="always">
            <div class="clearfix" slot="header">
              <span>Vip资源饼状图</span>
            </div>
            <div class="index-card" style="height:auto;">
              <div id="Original" style="height:446px;"></div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="12">
          <el-card class="box-card" shadow="always">
            <div class="clearfix" slot="header">
              <span>数据详情</span>
            </div>
            <el-table :data="list" stripe style="width: 100%; line-height:2.5em;">
              <el-table-column prop="name" label="来源类型"></el-table-column>
              <el-table-column prop="value" label="学生数量" sortable></el-table-column>
              <el-table-column prop="percent" label="占比" sortable>
                <template slot-scope="scope">
                  <span>{{getPercent(scope.row.value,true)}}</span>
                </template>
              </el-table-column>
            </el-table>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import echarts from "echarts";
import "echarts/theme/macarons.js";
import url from "@/plugins/urlHelper.js";
export default {
  data() {
    return {
      domain: url.getDomain(),
      query: {}, //对象
      loading: false,
      currentPage4: 1,
      pageSize: 10,
      tableData: [],
      dialogVisible: false,
      submiting: false,
      vipName: "vip1",
      list: [], //数据详情
      list2: [], //全部资源
      total: 0,
      total2: 0
    };
  },
  methods: {
    //vip
    getCollect() {
      var _this = this;
      //柱状图
      var link2 = url.getJapCollect("geteduback");
      var query = Object.assign({}, _this.query);
      query.isVip = true;
      $.get(link2, query, data => {
        _this.list = data;
        for (var i = 0; i < data.length; i++) {
          var item = data[i];
          _this.total += item.value;
        }
        // 基于准备好的dom，初始化echarts实例
        var myChart = echarts.init(
          document.getElementById("Original"),
          "macarons"
        );
        // 绘制图表
        myChart.setOption({
          title: {
            text: "日语资源学历汇总",
            subtext: "数据来自Crm系统",
            x: "center"
          },
          tooltip: {
            trigger: "item",
            formatter: "{a} <br/>{b} : {c} ({d}%)人申请"
          },
          series: [
            {
              name: "访问来源",
              type: "pie",
              radius: "55%",
              center: ["50%", "60%"],
              data: data,
              itemStyle: {
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)"
                }
              }
            }
          ]
        });
      });
    },

    //月份选择
    yearSearch() {
      if(this.query.time){
      this.query.start = this.query.time[0];
      this.query.end = this.query.time[1];
      }else{
      this.query.start = '';
      this.query.end = '';
      }
      this.getCollect();
    },
    //计算百分比
    getPercent(number, isVip) {
      var temp = 0;
      if (isVip) {
        if (this.total == 0) return 0;
        temp = (number / this.total) * 100;
      } else {
        if (this.total2 == 0) return 0;
        temp = (number / this.total2) * 100;
      }
      temp = temp.toFixed(2);
      return temp + "%";
    }
  },
  created() {},
  mounted() {
    this.getCollect();
  }
};
</script>

<style>
.query-form {
  margin-top: 20px;
  padding-top: 25px;
  background: #f2f2f2;
}
.el-form-item--small.el-form-item {
  margin-right: 0px;
}
.el-button--primary {
  margin-left: 10px;
}
</style>
